/**
 * Status step part renderer (Slice 4).
 */

/**
 * @param {Object} step
 * @returns {HTMLElement}
 */
export function createStatusStep(step) {
  const state = step.state || 'in_progress';
  const container = document.createElement('div');
  container.className = `ai-status-step ai-status-step--${state}`;
  container.setAttribute('role', 'status');
  container.setAttribute('aria-live', state === 'in_progress' ? 'polite' : 'off');

  const iconWrap = document.createElement('span');
  iconWrap.className = 'ai-status-step__icon';
  iconWrap.setAttribute('aria-hidden', 'true');

  if (state === 'in_progress') {
    const spinner = document.createElement('span');
    spinner.className = 'ai-status-step__spinner';
    iconWrap.appendChild(spinner);
  } else if (state === 'completed') {
    iconWrap.innerHTML = `
      <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true">
        <path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;
  } else if (state === 'failed') {
    iconWrap.innerHTML = `
      <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true">
        <path d="M4 4l8 8M12 4l-8 8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>`;
  }

  const label = document.createElement('span');
  label.className = 'ai-status-step__label';
  label.textContent = step.label || '';

  container.appendChild(iconWrap);
  container.appendChild(label);

  if (state !== 'in_progress' && step.result) {
    const result = document.createElement('span');
    result.className = 'ai-status-step__result';
    result.textContent = ` — ${step.result}`;
    container.appendChild(result);
  }

  return container;
}
